import React from "react";
import { RCCHookToast, RCCLov } from "react-common-components";
import ILovComponent from "react-common-components/dist/components/Lov/interface";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";

const LovBcgItems: React.FC<Omit<ILovComponent, "valueProperty" | "labelProperty" | "routeAPI">> = ({
	name,
	control,
	isCreatable,
	...rest
}) => {
	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	
	return(
		<RCCLov 
			name={name} 
			control={control}
			routeAPI="BCGItems/Lov"
			valueProperty="Taa013Id"
			labelProperty="Taa013Descricao"
			elementsPerPage={20}
			isCreatable = {isCreatable}
 			routeAPICreate="BCGItems/InsertFromLov"
 			formatCreateLabel={(userInput: string) => `+ ${translate("Criar novo Item BCG")}: ${userInput}`}
 			callbackErrorOnCreate={(err) => standardErrorMessages(err, translate("Erro ao adicionar Item BCG"), addToast)}
			{...rest}
		/>
	);};

export default LovBcgItems;
